<div class="flex flex-col gap-2 p-4 rounded-lg border border-green-500">
  <div class="flex flex-row items-start justify-between gap-3">
    <div class="flex flex-col gap-1">
      <p class="text-sm font-medium text-green-900">Vorschlag von chatBIC</p>
      @if (proposal.summary) {
        <p class="text-sm text-green-800">{{ proposal.summary }}</p>
      }
      @if (proposal.changeNotes?.length) {
        <ul class="flex flex-col gap-0.5 pl-4 list-disc">
          @for (note of proposal.changeNotes; track note.path) {
            <li class="text-sm text-green-800">
              <span class="font-mono">{{ note.path }}</span>
              @if (note.reason) {
                <span> – {{ note.reason }}</span>
              }
            </li>
          }
        </ul>
      }
      @if (proposal.stale) {
        <div class="flex items-start gap-2 mt-1">
          <fa-icon [icon]="faTriangleExclamation" class="text-yellow-700 text-sm shrink-0 mt-0.5"></fa-icon>
          <span class="text-sm font-medium text-yellow-900">
            Der myCheck wurde seitdem bereits gespeichert – dieser Vorschlag basiert nicht mehr auf dem aktuellen Stand.
          </span>
        </div>
      }
    </div>
    <div class="flex flex-row items-center gap-2 shrink-0">
      <bic-button (onClick)="discardClicked.emit()" buttonType="white">Verwerfen</bic-button>
      <bic-button (onClick)="applyClicked.emit()" buttonType="primary">Änderungen übernehmen</bic-button>
    </div>
  </div>
</div>
